import NumericEnum from '@square/dashboard-utilities/utils/numeric-enum';
export default NumericEnum.create(['PUBLIC',
// Visibile to seller and buyer, default
'PRIVATE',
// Visibile to seller
'PUBLIC_ONLY' // Visibilie to buyer
]);